// 3. PURE HELPERS
const validateUploadedFiles = (_, files = []) =>
	files.some((file) => !file.url || file.status === "uploading" || file.status === "error")
		? Promise.reject(new Error("Vui lòng chờ tải ảnh thành công hoặc tải lại ảnh"))
		: Promise.resolve();

// 6. VALIDATION PATTERNS
const VIETNAM_PHONE_PATTERN = /^(0)(3[2-9]|5[6|8|9]|7[0|6-9]|8[1-9]|9[0-9])[0-9]{7}$/;
const DIGITS_PATTERN = /^\d+$/;
const ALPHANUMERIC_PATTERN = /^[A-Za-z0-9]+$/;

// 9. EXPORTS
export { VIETNAM_PHONE_PATTERN, DIGITS_PATTERN, ALPHANUMERIC_PATTERN, validateUploadedFiles };